import {
  Flex,
  Icon,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  CircularProgress,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  formatDataTimeStamp,
  formatDataTimeStampSemHora,
  IsEmpty,
} from "config/functions";
import { MdErrorOutline, MdSearch } from "react-icons/md";

// Importações
import {
  getLinhas,
  getImagemTransacao,
  obterTransacaoDetalhe,
} from "config/apis/requests";
import React from "react";

export default function TransacoesFraude(props: { item?: any[]; modal: any[]; operadoras?: any[]; midias?: any[]; }): JSX.Element {
  const { item, modal, operadoras, midias } = props;
  const [imagemTransacao, setImagemTransacao] = useState<any>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [linhasList, setLinhasList] = useState<any[]>([]);
  const [selectedTransacao, setSelectedTransacao] = useState<any>(null);
  const [fullScreenImage, setFullScreenImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [idTipoMidiaExtrato, setIdTipoMidiaExtrato] = useState<number | string | null>(null);

  const handleOpenModal = (item: any) => {
    setSelectedTransacao(item);

    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario")!.style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2")!.style.display = "none";
    onOpen();
  };

  const handleCloseModal = () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario")!.style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2")!.style.display = "block";
  };

  const statusTipoMidia = (status: any) => {
    switch (Number(status)) {
      case 1:
        return "Cartão Cipurse";
      case 4:
        return "Cartão Secora";
      case 2:
        return "QR Code";
      case 3:
        return "NFC";
      default:
        return "Não informado";
    }
  };

  const buscarImagemTransacao = async (idImagemTransacao: any) => {
    setLoading(true);
    setIdTipoMidiaExtrato(null);
    if (linhasList.length === 0) {
      try {
        const linhas = await getLinhas();
        setLinhasList(linhas);
      } catch (err) {
        console.error("Erro ao buscar linhas", err);
      }
    }

    try {
      const img = await getImagemTransacao(idImagemTransacao);

      if (img && !IsEmpty(img?.imagem) && img !== 500 && img !== 404 && img !== 400) {
        setImagemTransacao(img);
        const { panHash, dataTransacao, idTransacao } = img;

        if (panHash && dataTransacao && idTransacao) {
          const dataObj = new Date(dataTransacao);
          const dataTransacaoTimestampUTC = dataObj.getTime() + (dataObj.getTimezoneOffset() * 60000);
          const bodyTransacao = {
            panHash: panHash,
            dataTransacao: dataTransacaoTimestampUTC,
            idTransacao: idTransacao
          };
          const transacaoDetalhe = await obterTransacaoDetalhe(bodyTransacao);

          if (transacaoDetalhe && (transacaoDetalhe.idTipoMidia !== null && transacaoDetalhe.idTipoMidia !== undefined)) {
            setIdTipoMidiaExtrato(transacaoDetalhe.idTipoMidia);
          }
        }
      }
    } catch (error) {
      console.error("Erro no fluxo de buscar imagem e detalhes:", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    const id = selectedTransacao?.[0]?.idImagemTransacao;

    if (id) {
      buscarImagemTransacao(id);
    }
  }, [selectedTransacao]);

  const getDescricaoLinha = (selected: any) => {
    const linhaSelecionada = linhasList.find(
      (linha) => Number(linha.id) === Number(selected?.cdLinha)
    );

    if (linhaSelecionada) {
      const nomeLinha = linhaSelecionada.nomeLinha;
      const numeroLinha = linhaSelecionada.numeroLinha;

      const idMidiaFinal = idTipoMidiaExtrato || imagemTransacao?.idTipoMidia || imagemTransacao?.id_tipo_midia;

      return (
        <Flex direction="column" gap="4px">
          <Text>
            <b>Linha:</b> {nomeLinha}
          </Text>
          <Text>
            <b>Número linha:</b> {numeroLinha}
          </Text>
          <Text>
            <b>Modal:</b> {
              props.modal?.find((m: any) =>
                String(m.id).trim() === String(imagemTransacao?.idTipoModal).trim()
              )?.descricao || "N/A"
            }
          </Text>
          <Text>
            <b>Operadora:</b> {
              props.operadoras?.find((o: any) =>
                String(o.id).trim() === String(imagemTransacao?.cdOperadora)
              )?.cliente?.nome || "N/A"
            }
          </Text>
          <Text>
            <b>Validador:</b> {imagemTransacao?.numeroSerieValidador || "N/A"}
          </Text>

          <Text>
            <b>Tipo de mídia:</b> {statusTipoMidia(idMidiaFinal)}
          </Text>

          {(() => {

            const status = item?.[0]?.idStatusPenalizacaoCliente;
            if (status === 1) {
              return (
                <Flex direction="column" mt="12px" p="10px" bg="blue.50" borderRadius="md" borderLeft="4px solid" borderColor="blue.300">
                  <Text color="blue.700" fontWeight="bold" fontSize="sm">
                    Notificação de Orientação
                  </Text>
                  <Text fontSize="sm" fontStyle="italic" color="gray.700">
                    Este uso indevido não gerou penalização ou bloqueio imediato.
                  </Text>
                </Flex>
              );
            }
            if (status === 2) {
              return (
                <Flex direction="column" mt="12px" p="12px" bg="red.50" borderRadius="md" borderLeft="4px solid" borderColor="red.400">
                  <Text color="red.700" fontWeight="bold" fontSize="sm" mb="4px">
                    Uso Indevido Confirmado
                  </Text>
                  <Text fontSize="sm">
                    <b>Nº Ocorrência:</b> {item[0]?.seqOcorrencia}ª
                  </Text>
                  <Text fontSize="sm">
                    <b>Tempo de Bloqueio:</b> {item[0]?.tempoBloqueioDias} dias
                  </Text>
                  <Text fontSize="sm">
                    <b>Data para Desbloqueio:</b> {formatDataTimeStampSemHora(item[0]?.dataFimBloqueio)}
                  </Text>
                </Flex>
              );
            }
            if (status === 3) {
              return (
                <Flex align="center" mt="12px" p="10px" bg="green.50" borderRadius="md" border="1px solid" borderColor="green.200">
                  <Text color="green.700" fontSize="sm" fontWeight="medium">
                    <b>Status:</b> Ocorrência expirada
                  </Text>
                </Flex>
              );
            }
            return null;
          })()}
        </Flex>
      );
    }
  };

  return (
    <Flex>
      {item && item.length > 0 &&
        item.map((imagem, index) => (
          <Flex
            key={index}
            w="100%"
            align="left"
            alignItems={"flex-start"}
            verticalAlign={"left"}
            py="10px"
            _hover={{ bg: "gray.50" }}
            transition="background 0.2s"
          >
            <Icon as={MdErrorOutline} color="red.400" w={7} h={7} mr="14px" />
            <Text flex="1" fontSize="md" color="gray.800">
              <b>Data:</b>
              {"   "} {formatDataTimeStamp(item[0]?.dataTransacao)}
            </Text>
            <Icon
              as={MdSearch}
              color="gray.500"
              w={6}
              h={6}
              cursor="pointer"
              ml="10px"
              title="Ver detalhes"
              onClick={() => handleOpenModal(item)}
            />
          </Flex>
        ))}
      <Modal
        isOpen={isOpen}
        onClose={() => {
          onClose();
          handleCloseModal();
        }}
        size="3xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detalhes da Transação</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {selectedTransacao && (
              <Flex
                direction={{ base: "column", md: "row" }}
                gap="24px"
                alignItems="flex-start"
              >
                <Flex
                  direction="column"
                  align="center"
                  bg="gray.50"
                  borderRadius="md"
                  boxShadow="sm"
                  p="10px"
                  flex="1"
                  w={{ base: "100%", md: "50%" }}
                >
                  <Text fontWeight="bold" mb="6px" fontSize="sm">
                    Imagem da Transação{" "}
                  </Text>
                  {loading ? (
                    <Flex justify="center" px="10px" pt="5px" mb="25px">
                      <CircularProgress
                        isIndeterminate
                        color="green.300"
                        size="40px"
                      />
                    </Flex>
                  ) : selectedTransacao[0]?.idImagemTransacao ? (
                    <img
                      src={
                        "data:image/jpeg;base64," + imagemTransacao?.imagem ||
                        ""
                      }
                      alt="Transação"
                      style={{
                        maxWidth: "100%",
                        borderRadius: 4,
                        maxHeight: "400px",
                        objectFit: "contain",
                        cursor: "pointer",
                        border: "3px solid #E53E3E",
                      }}
                      onClick={() =>
                        setFullScreenImage(
                          "data:image/jpeg;base64," + imagemTransacao?.imagem
                        )
                      }
                      title="Clique para ampliar"
                    />
                  ) : (
                    <Text color="red.400" fontSize="xs">
                      Sem imagem
                    </Text>
                  )}
                </Flex>

                {/* LADO DIREITO: INFORMAÇÕES */}
                <Flex
                  direction="column"
                  flex="1"
                  w={{ base: "100%", md: "50%" }}
                  gap="4px"
                >
                  <Text>
                    <b>Data:</b>{" "}
                    {formatDataTimeStamp(
                      item?.[0]?.dataTransacao
                    )}
                  </Text>

                  {getDescricaoLinha(imagemTransacao)}
                </Flex>
              </Flex>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* MODAL FULLSCREEN DA IMAGEM */}
      <Modal
        isOpen={!!fullScreenImage}
        onClose={() => {
          setFullScreenImage(null);
          handleCloseModal();
        }}
        size="auto"
        isCentered
      >
        <ModalOverlay />
        <ModalContent boxShadow="none" bg="transparent" maxW="unset">
          <ModalCloseButton
            color="white"
            bg="rgba(0,0,0,0.5)"
            borderRadius="full"
          />
          <ModalBody
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={0}
            onClick={() => setFullScreenImage(null)}
          >
            {fullScreenImage && (
              <img
                src={fullScreenImage}
                alt="Imagem em tela cheia"
                onClick={(e) => e.stopPropagation()}
                style={{
                  display: "block",
                  maxWidth: "90vw",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
}